import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);

  const token = keycloak.token;
  const apiUrl = environment.apiUrl;

  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  const apiReq = req.clone({
    url: `${apiUrl}/${req.url}`.replace(/([^:]\/)\/+/g, '$1'),
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(apiReq);
};
